import React from 'react';
import {createRoot} from 'react-dom/client';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';

function importAll(r) {
    r.keys().forEach(r);
};

importAll(require.context('./libs/'));
importAll(require.context('./components/'));

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <App/>
);
